import {api} from '@/http'

// 岗位详情
const getPositionDesc = (id, callback, back) => {
  api('/api/position/' + id, 'get', '', callback, back)
}

// 岗位收藏
const positionFavorites = (id, data, callback, back) => {
  api('/api/position/' + id + '/favorites', 'post', data, callback, back)
}

// 感兴趣的岗位
const getPositionLike = (id, data, callback, back) => {
  api('/api/position/' + id + '/interested', 'get', data, callback, back)
}

export default {
  getPositionDesc,
  positionFavorites,
  getPositionLike
}



// WEBPACK FOOTER //
// ./src/api/positionDetail/index.js